export enum eChevronColor {
    Green = 'chevron-color-green',
    Black = 'chevron-color-black',
    White = 'chevron-color-white',
}